import * as React from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'antd/lib/modal';
import Alert from 'antd/lib/alert';
import Text from 'antd/lib/typography/Text';
import { TRY_ADD_ISSUE_SOURCES, tryAddIssueSources } from '@/actions/triage';
import { useError, useIsLoading, useUpdated } from '@/utils/hooks/helpers';
import { IssueCandidatesSelect } from './IssueCandidatesSelect';

interface AddSourceModalProps {
    open: boolean;
    onClose: () => void;
    orgId: string;
    appId: string;
    issueId: string;
}

export const AddSourceModal: React.FC<AddSourceModalProps> = ({ open, onClose, orgId, appId, issueId }) => {
    const dispatch = useDispatch();
    const [selectedIssueIds, setSelectedIssueIds] = React.useState<string[]>([]);

    const isSaving = useIsLoading(TRY_ADD_ISSUE_SOURCES, issueId);
    const saveError = useError(TRY_ADD_ISSUE_SOURCES, issueId);
    const saveSucceeded = useUpdated(TRY_ADD_ISSUE_SOURCES, issueId);

    React.useEffect(() => {
        if (saveSucceeded) {
            setSelectedIssueIds([]);
            onClose();
        }
    }, [saveSucceeded]);

    const onSubmit = () => {
        dispatch(tryAddIssueSources({ orgId, appId, issueId, sourceIssueIds: selectedIssueIds }));
    };

    return (
        <Modal
            title="Add source"
            open={open}
            onCancel={onClose}
            onOk={onSubmit}
            okText={selectedIssueIds.length > 1 ? 'Add sources' : 'Add source'}
            okButtonProps={{ disabled: selectedIssueIds.length === 0 }}
            confirmLoading={isSaving}
            destroyOnClose
            width={560}
        >
            {saveError && <Alert type="error" message={saveError} showIcon style={{ marginBottom: 16 }} />}
            <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
                Pull a source from another &quot;Needs triage&quot; issue into this one. The source is moved and its
                original issue is removed.
            </Text>
            <IssueCandidatesSelect
                orgId={orgId}
                appId={appId}
                open={open}
                excludeIssueIds={[issueId]}
                value={selectedIssueIds}
                onChange={setSelectedIssueIds}
            />
        </Modal>
    );
};
